jQuery($ => {
    class MenuOptions {
      constructor(element) {
        this._        = element;
        this._element = $(element);
        this._list    = this._element.find('.m-menu-options__list');
        this._item    = this._list.find('.m-menu-options__item');
        this._option  = this._item.find('.m-menu-options__option');
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._option.on('click', this.handleOptionClick.bind(this));
        this._option.on('keydown', this.handleOptionKeydown.bind(this));
        this._option.on('activate', this.handleOptionActivate.bind(this));
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Get Controlled Element
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      getControlledElement = target => {
        const ariaControls = $(target).attr('aria-controls');

        if (!ariaControls) return;

        const $controlledElement = $(`#${ariaControls}`);

        if (!$controlledElement[0]) return;

        return $controlledElement;
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Option Click
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleOptionClick = event => {
        const $option            = $(event.currentTarget);
        const $controlledElement = this.getControlledElement(event.currentTarget);

        if (!$controlledElement) return;

        event.preventDefault();

        this._element.trigger('control', [$controlledElement, $option]);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Option Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleOptionKeydown = event => {
        const $option            = $(event.currentTarget);
        const $controlledElement = this.getControlledElement(event.currentTarget);

        const $list = $option.closest('.m-menu-options__list');
        const $item = $option.closest('.m-menu-options__item');

        const $firstItem   = $list.find(".m-menu-options__item").first();
        const $firstOption = $firstItem.find(".m-menu-options__option");
        const $lastItem    = $list.find(".m-menu-options__item").last();
        const $lastOption  = $lastItem.find(".m-menu-options__option");

        const computedStyle = getComputedStyle(this._list[0]);
        const cols = parseInt(computedStyle.getPropertyValue('--cols')) || 1;
        const rows = parseInt(computedStyle.getPropertyValue('--rows')) || 1;

        const currentIndex = this._item.index($item);

        const currentCol = Math.floor(currentIndex / rows);
        const currentRow = currentIndex % rows;

        switch (event.key) {
          case 'Enter':
          case 'spacebar':
          case ' ':
            if (!$controlledElement) return;

            event.preventDefault();

            this._element.trigger('control', [$controlledElement, $option]);
            break;

          case 'ArrowUp':
            event.preventDefault();
            
            const $prevItem = $item.prev();

            if ($prevItem[0]) {
              $prevItem.find(".m-menu-options__option").focus();
            } else {
              $lastOption.focus();
            }
            break;

          case 'ArrowDown':
            event.preventDefault();
            const $nextItem = $item.next();

            if ($nextItem[0]) {
              $nextItem.find(".m-menu-options__option").focus();
            } else {
              $firstOption.focus();
            }
            break;

          case 'ArrowLeft':
            event.preventDefault();

            if (cols === 1) {
              this._element.trigger('keyToEdge',['left',event.currentTarget]);
              return;
            }
  
            const newColLeft = currentCol - 1;
            if (newColLeft >= 0) {
              const newIndexLeft = newColLeft * rows + currentRow;
              const $leftItem = this._item.eq(newIndexLeft);
              if ($leftItem[0]) {
                $leftItem.find(".m-menu-options__option").focus();
              }
            } else {
              this._element.trigger('keyToEdge',['left',event.currentTarget]);
              // Optionally, wrap around to the last column
              // const newIndexLeft = (cols - 1) * rows + currentRow;
              // const $leftItem = this._item.eq(newIndexLeft);
              // if ($leftItem[0]) {
              //   $leftItem.find(".m-menu-options__option").focus();
              // }
            }
            break;
  
          case 'ArrowRight':
            event.preventDefault();

            if (cols === 1) {
              this._element.trigger('keyToEdge',['right',event.currentTarget]);
              return;
            }
  
            const newColRight = currentCol + 1;
            if (newColRight < cols) {
              const newIndexRight = newColRight * rows + currentRow;
              const $rightItem = this._item.eq(newIndexRight);
              if ($rightItem[0]) {
                $rightItem.find(".m-menu-options__option").focus();
              }
            } else {
              this._element.trigger('keyToEdge',['right',event.currentTarget]);
              // Optionally, wrap around to the first column
              // const newIndexRight = currentRow;
              // const $rightItem = this._item.eq(newIndexRight);
              // if ($rightItem[0]) {
              //   $rightItem.find(".m-menu-options__option").focus();
              // }
            }
            break;

          case 'Home':
            event.preventDefault();
            $firstOption.focus();
            break;

          case 'End':
            event.preventDefault();
            $lastOption.focus();
            break;
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Option Activate
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleOptionActivate = event => {
        const $currentOption = $(event.currentTarget);
        const activeClass    = 'm-menu-option--active';

        $option.removeClass(activeClass);
        $currentOption.addClass(activeClass);
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.menu_options = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].menu_options = new MenuOptions(_[i], opt);
        else
          ret = _[i].menu_options[opt].apply(_[i].menu_options, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-menu-options').menu_options();
});